import { useUserStore } from "@/stores/user";
import { useTeamStore } from "@/stores/team";
import { useDepartmentStore } from "@/stores/department";
import { ticketCategories } from "@/components/InboxLeftMenu.utils.js";
import {
  InteractionPageEnum,
  ThreadCategoryStatusEnum,
  TicketCategoryStatusEnum,
  InteractionSortOptionEnum,
  ThreadStatusEnum,
  PLACEHOLDER_UUID,
  InteractionSourceEnum,
} from "@/utils/constants.js";

export function useInboxDefaultParams() {
  const userStore = useUserStore();
  const teamStore = useTeamStore();
  const departmentStore = useDepartmentStore();

  function getDefaultInboxQueryParams(category) {
    const userId = userStore.user?.id;
    const userTeams = teamStore.getUserTeams(userId);
    const userTeamsIds =
      userTeams.length > 0
        ? userTeams.map((teamObj) => teamObj._id)
        : [PLACEHOLDER_UUID];
    const userDepartments = departmentStore.getUserSupportDepartments(userId);
    const userDepartmentIds =
      userDepartments.length > 0
        ? userDepartments.map((dept) => dept._id)
        : [PLACEHOLDER_UUID];

    const params = {
      page: 1,
      limit: 10,
      sort_option: InteractionSortOptionEnum.MOST_RECENT,
    };

    const ticketCategoryKeys = Object.keys(ticketCategories);
    if (
      category !== InteractionPageEnum.UNKNOWN_USER_TICKETS &&
      ticketCategoryKeys
        .filter((k) => k !== InteractionPageEnum.MY_DRAFTS)
        .includes(category)
    ) {
      params.status = [
        TicketCategoryStatusEnum.NEW,
        TicketCategoryStatusEnum.REOPENED,
        TicketCategoryStatusEnum.ESCALATED,
        TicketCategoryStatusEnum.OPEN,
        TicketCategoryStatusEnum.PENDING_USER_REPLY,
      ];
    }

    switch (category) {
      case InteractionPageEnum.ALL_TICKETS:
        break;
      case InteractionPageEnum.MY_TICKETS:
        params.assignees = userId;
        params.teams = userTeamsIds;
        break;
      case InteractionPageEnum.MY_TEAMS:
        params.teams = userTeamsIds;
        break;
      case InteractionPageEnum.MY_DEPARTMENTS:
        params.department = userDepartmentIds;
        break;
      case InteractionPageEnum.MY_DRAFTS:
        params.my_draft = true;
        break;
      case InteractionPageEnum.ALL_SOFT_ALERTS:
        params.status = ThreadCategoryStatusEnum.SOFT_ALERT;
        break;
      case InteractionPageEnum.MY_SOFT_ALERTS:
        params.status = ThreadCategoryStatusEnum.SOFT_ALERT;
        params.assignees = userId;
        break;
      case InteractionPageEnum.ALL_INTERACTIONS:
        params.sort_option = InteractionSortOptionEnum.MOST_RECENT;
        break;
      case InteractionPageEnum.VA_INTERACTIONS:
        params.status = [ThreadStatusEnum.AI_ONGOING, ThreadStatusEnum.AI_CLOSED];
        params.sort_option = InteractionSortOptionEnum.MOST_RECENT;
        break;
      case InteractionPageEnum.UNKNOWN_USER_TICKETS:
        params.sort_option =
          InteractionSortOptionEnum.CREATED_TIME_NEWEST_TO_OLDEST;
        params.source = InteractionSourceEnum.UNKNOWN_USER_TICKET;
        break;
    }

    return params;
  }

  return { getDefaultInboxQueryParams };
}
